<script>
import Campus from "@/components/modals/campus.vue";
import {required} from "vuelidate/lib/validators";
export default {
    name: 'PoItemUpdate',
    components: {
        Campus
    },
    props: {
        modalTitle: {
            type: String,
            default: ''
        }
    },
    validations: {
        form: {
            campusId: {required},
        }
    },
    data() {
        return {
            form: {
                campusId: null,
                campusName: '',
                poId: null
            },
            submitted: false
        };
    },
    methods: {
        resetForm() {
            this.form = {
                campusId: null,
                campusName: '',
                poId: null
            };
            this.submitted = false;
        },
        getCampus() {
            this.$refs.campus.getData();
            this.$bvModal.show("campus-modal");
        },
        dropCampus(data) {
            this.form.campusId = data.id;
            this.form.campusName = data.campusName;
        },
        onTransfer() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            let data = JSON.parse(JSON.stringify(this.form));
            this.$emit('transfer', data);
        }
    }
};
</script>
<template>
    <b-modal 
        id="modal-transfer-campus" 
        :title="modalTitle" 
        size="md" 
        title-class="font-18" 
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="onTransfer" class="needs-validation" ref="fcForm">
            <label for="supplier">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
            <b-input-group>
                <template #append>
                    <b-button 
                        @click="getCampus()" 
                        variant="outline-info" 
                        :title="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
                    >
                        <i class="mdi mdi-clipboard-text-search-outline"></i>
                    </b-button>
                </template>
                <input 
                    autocomplete="off" 
                    type="text" 
                    :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" 
                    disabled 
                    class="form-control" 
                    :class="{'is-invalid': submitted && $v.form.campusId.$error}" 
                    v-model="form.campusName" 
                />
            </b-input-group>
            <div v-if="submitted && $v.form.campusId.$error" class="invalid-feedback">
                <span>This value is required.</span>
            </div>
            <div class="d-flex justify-content-end mt-2 border-top border-1">
                <button class="btn btn-primary mt-2" type="submit">Transfer</button>
            </div>
        </form>
        <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
    </b-modal>
</template>